import React, { useState } from 'react';
import { FaClipboardCheck, FaTimes, FaPen } from 'react-icons/fa';
import { FinField, FinTextarea } from '../../../components/FinField';
import { moeda } from '../../../util/util';
import '../../../css/financeiro-parcela-pagar.css';

// D-0056 (Rafael 03/11): o envio para Faturamento só sai com tudo verde. A MESMA lista
// (`checklist` do GET orcamento/{id}/faturamento, montada em FaturamentoChecklist na API)
// aparece no pré-envio — o operador vê o que falta e onde resolver, e justifica pago ≠ orçado —
// e na conferência do Financeiro, que só confere (editavel = false).

const PILL = {
    ok: { classe: 'is-ok', texto: 'OK' },
    falta: { classe: 'is-danger', texto: 'Falta' },
    aviso: { classe: 'is-warn', texto: 'Aviso' },
};

function reais(valor) {
    return 'R$ ' + moeda(valor);
}

function dataHora(valor) {
    var t = String(valor || '');
    if (t.length < 16) return '';
    return t.substr(8, 2) + '/' + t.substr(5, 2) + '/' + t.substr(0, 4) + ' ' + t.substr(11, 5);
}

export default function ChecklistFaturamento({ checklist, editavel, onJustificar }) {
    const [justificando, setJustificando] = useState(null); // linha pendente do item "valores"
    const [texto, setTexto] = useState('');
    const [salvando, setSalvando] = useState(false);

    if (!checklist || !Array.isArray(checklist.itens)) return null;

    const itens = checklist.itens;
    const verdes = itens.filter(function (i) { return i.situacao === 'ok'; }).length;
    const faltas = itens.filter(function (i) { return i.situacao === 'falta'; }).length;

    const abrir = function (linha) {
        setJustificando(linha);
        setTexto(linha.justificativa || '');
    };
    const fechar = function () {
        if (salvando) return;
        setJustificando(null);
        setTexto('');
    };
    const salvar = function () {
        if (!justificando || texto.trim() === '' || salvando || !onJustificar) return;
        setSalvando(true);
        Promise.resolve(onJustificar(justificando.fornecedor_id, texto.trim()))
            .then(function (ok) { if (ok !== false) { setJustificando(null); setTexto(''); } })
            .finally(function () { setSalvando(false); });
    };

    return (
        <section className="fin-pp__region" style={{ marginBottom: 18 }} data-faturamento-checklist={checklist.pode_enviar ? 'verde' : 'falta'}>
            <div className="fin-pp__cphead">
                <span className="fin-pp__cphead-ic"><FaClipboardCheck size={16} /></span>
                <div style={{ minWidth: 0, flex: 1 }}>
                    <h2 className="fin-pp__cphead-title">Checklist do Faturamento</h2>
                    <p className="fin-pp__cphead-sub">
                        {editavel
                            ? 'O envio só libera com todos os itens que bloqueiam em verde. Aviso não impede o envio.'
                            : 'O que foi conferido antes do envio. Tudo em verde = é só conferir e gerar os documentos.'}
                    </p>
                </div>
                <span className={'fin-pp__pill ' + (checklist.pode_enviar ? 'is-ok' : 'is-danger')}>
                    {checklist.pode_enviar
                        ? (editavel ? 'Pronto para enviar' : 'Tudo verde')
                        : faltas + (faltas === 1 ? ' item falta' : ' itens faltam')}
                </span>
            </div>

            <div className="fin-pp__region-body">
                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl">
                            <thead>
                                <tr>
                                    <th style={{ width: 90 }}>Status</th>
                                    <th style={{ width: 260 }}>Item</th>
                                    <th>O que falta</th>
                                    <th style={{ width: 170 }}>Onde resolver</th>
                                </tr>
                            </thead>
                            <tbody>
                                {itens.map(function (item) {
                                    var pill = PILL[item.situacao] || PILL.aviso;
                                    var pendentes = item.pendentes || [];
                                    var justificados = item.justificados || [];
                                    return (
                                        <tr key={item.chave} data-checklist-item={item.chave}>
                                            <td><span className={'fin-pp__pill ' + pill.classe}>{pill.texto}</span></td>
                                            <td className="fin-pp__cell-strong" style={{ whiteSpace: 'normal' }}>
                                                {item.titulo}
                                                {!item.bloqueia && <div className="fin-pp__cell-muted" style={{ fontWeight: 400 }}>não bloqueia o envio</div>}
                                            </td>
                                            <td style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                                {pendentes.length === 0 && justificados.length === 0 && (
                                                    <span className="fin-pp__cell-muted">Nada pendente.</span>
                                                )}
                                                {pendentes.map(function (p, i) {
                                                    return (
                                                        <div key={item.chave + '-p-' + i} style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginBottom: 4 }}>
                                                            <span style={{ flex: 1, minWidth: 0 }}>{p.texto}</span>
                                                            {item.justificavel && editavel && onJustificar && (
                                                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={function () { abrir(p); }}>
                                                                    <FaPen size={11} /> Justificar
                                                                </button>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                                {justificados.map(function (j, i) {
                                                    return (
                                                        <div key={item.chave + '-j-' + i} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', flexWrap: 'wrap', marginBottom: 4 }}>
                                                            <span className="fin-pp__minitag is-ok" style={{ flex: 'none' }}>Justificado</span>
                                                            <span style={{ flex: 1, minWidth: 0 }}>
                                                                {j.texto} <em>"{j.justificativa}"</em>
                                                                <span className="fin-pp__cell-muted">
                                                                    {j.justificado_por ? ' — ' + j.justificado_por : ''}
                                                                    {j.justificado_em ? ', ' + dataHora(j.justificado_em) : ''}
                                                                </span>
                                                            </span>
                                                            {editavel && onJustificar && (
                                                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={function () { abrir(j); }}>
                                                                    <FaPen size={11} /> Editar
                                                                </button>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </td>
                                            <td className="fin-pp__cell-muted" style={{ whiteSpace: 'normal' }}>
                                                {item.situacao === 'ok' ? '—' : item.onde}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
                <p className="fin-pp__cell-muted" style={{ margin: '8px 2px 0' }}>
                    {verdes} de {itens.length} itens em verde.
                </p>
            </div>

            {justificando && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg"
                    onClick={function (e) { if (e.target === e.currentTarget) fechar(); }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic"><FaPen size={15} /></span>
                                <h3 className="fin-pp__modal-title">Justificar diferença
                                    <span className="fin-pp__modal-sub">
                                        {justificando.fornecedor_nome}: orçado {reais(justificando.valor_orcado)}, pago {reais(justificando.valor_pago)}
                                    </span>
                                </h3>
                                <button type="button" className="fin-pp__modal-close" onClick={fechar}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                <div className="fin-pp__filters">
                                    <FinField label="Por que o pago é diferente do orçado?" required full>
                                        <FinTextarea value={texto} rows={4}
                                            placeholder="Ex.: cortesia do hotel, desconto negociado, item cancelado"
                                            onChange={function (e) { setTexto(e.target.value); }} />
                                    </FinField>
                                </div>
                                <p className="fin-pp__cell-muted" style={{ margin: '8px 0 0' }}>
                                    O Financeiro vai ver este texto na conferência. Se o orçado ou o pago mudarem, a justificativa deixa de valer.
                                </p>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn" onClick={fechar} disabled={salvando}>Cancelar</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--primary" onClick={salvar}
                                    disabled={salvando || texto.trim() === ''}>
                                    {salvando ? 'Salvando…' : 'Salvar justificativa'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}
